export const formatPersOrgNr = (persOrgNr: string) => {
  if (!persOrgNr) {
    return '';
  }
  return persOrgNr.length === 10
    ? `${persOrgNr.slice(0, 6)}-${persOrgNr.slice(6, 10)}`
    : persOrgNr;
};
